export default __webpack_public_path__ + "static/media/TV_Aparecida.cf4d4f90.png";